"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _hr = require("@dbi-tools/ui-kit/lib/hr");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HrUi = function HrUi(props) {
  return /*#__PURE__*/_react.default.createElement(_hr.Hr, props);
};

var _default = HrUi;
exports.default = _default;